import React from "react";
import { cn } from "../../../lib/utils";

/** A zone / section heading in the admin's type scale (`font-display text-2xl`), right-hand slot optional. */
export default function SectionHeading({ title, aside, right, className, level = 2, id }) {
  const Tag = level === 3 ? "h3" : "h2";
  return (
    <div className={cn("flex flex-wrap items-baseline justify-between gap-3 mb-3", className)}>
      <Tag id={id} className={cn("text-eh-ink", level === 3 ? "text-base font-semibold" : "font-display text-2xl")}>
        {title}
        {aside && <span className="ml-2 text-eh-muted">{aside}</span>}
      </Tag>
      {right}
    </div>
  );
}
